import axios from "axios";

export default axios.create({
    baseURL: "https://figpindb-api.netlify.app/.netlify/functions",
    headers: {
        "Content-type": "application/json"
    }
});
